var global = require('../internals/global');
var isCallable = require('../internals/is-callable');

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/weak-map-basic-detection.js
// module id = 2229
// module chunks = 0